import React, { useState } from "react";

const Student1 = () => {
    const options = ["React", "Vue", "Angular", "Svelte", "Next.js"];

    const [selectedTech, setSelectedTech] = useState("");
    const [selectedList, setSelectedList] = useState(["", ""]);
    const [mentorFees, setMentorFees] = useState(["", ""]);

    const handleChange = (e) => {
        setSelectedTech(e.target.value);
    };

    const handleAdd = () => {
        if (!selectedTech) return;

        if (selectedList.includes(selectedTech)) {
            alert("Already added");
            return;
        }

        const emptyIndex = selectedList.findIndex((item) => item === "");
        if (emptyIndex === -1) {
            alert("Only 2 selections allowed");
            return;
        }
        

        const updatedList = [...selectedList];
        updatedList[emptyIndex] = selectedTech;

        const updatedFees = [...mentorFees];
        updatedFees[emptyIndex] = ""; // Clear fee field for new selection

        setSelectedList(updatedList);
        setMentorFees(updatedFees);
        setSelectedTech("");
    };

    const handleReset = () => {
        setSelectedTech("");
        setSelectedList(["", ""]);
        setMentorFees(["", ""]);
    };

    const handleFeeChange = (index, value) => {
        const updatedFees = [...mentorFees];
        updatedFees[index] = value;
        setMentorFees(updatedFees);
    };

    return (
        <div>
            <label>Select Tech:</label>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <select value={selectedTech} onChange={handleChange}>
                    <option value="" disabled>Select</option>
                    {options.map((opt, index) => (
                        <option key={index} value={opt}>
                            {opt}
                        </option>
                    ))}
                </select>
                <button type="button" onClick={handleAdd}>
                    Add
                </button>
                <button
                    type="button"
                    onClick={handleReset}
                    style={{ backgroundColor: "#e57373", color: "white" }}
                >
                    Reset
                </button>
            </div>

            <div style={{ marginTop: "10px" }}>
                {selectedList.map((mentor, index) =>
                    mentor ? (
                        <div key={index} style={{ marginBottom: "10px" }}>
                            <input
                                type="text"
                                value={mentor}
                                readOnly
                                placeholder={`Mentor ${index + 1}`}
                                style={{ marginRight: "10px", backgroundColor: "#f0f0f0" }}
                            />
                            <input
                                type="number"
                                value={mentorFees[index]}
                                onChange={(e) => handleFeeChange(index, e.target.value)}
                                placeholder="Mentor Fees"
                                style={{ width: "150px" }}
                            />
                        </div>
                    ) : null
                )}
            </div>
        </div>
    );
};

export default Student1;
{/* <div style={{ marginBottom: "20px" }}>
<label style={{ fontWeight: "bold", marginBottom: "8px", display: "block" }}>
    Mentor Name: <span style={{ color: "red" }}>*</span>
</label>

<div style={{
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "300px"
}}>
    <div>
        <select
            name="mentorname"
            value={formData.mentorname}
            onChange={handleChange}
            required
            style={{
                padding: "8px",
                width: "100%",
                borderRadius: "4px",
                border: "1px solid #ccc"
            }}
        >
            <option value="" disabled>Select a Mentor</option>
            {mentor.map((mentor, index) => (
                <option key={index} value={mentor.name}>
                    {mentor.name}
                </option>
            ))}
        </select>
    </div>

    <div style={{ display: "flex", gap: "10px" }}>
        <button
            type="button"
            // onClick={handleAdd}
            style={{
                padding: "8px 16px",
                backgroundColor: "#4caf50",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer"
            }}
        >
            Add
        </button>

        <button
            type="button"
            // onClick={handleReset}
            style={{
                padding: "8px 16px",
                backgroundColor: "#e57373",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer"
            }}
        >
            Reset
        </button>
    </div>
</div>
</div> */}